import React from "react";
import "./ProgressIndicators.scss";
import { getRandomNumber } from "../../../shared/utils/sharedUtils";

const ProgressIndicator = (props: any) => {

  const { sectionName, sectionLevel } = props
  return (
    <div className="stepprogress">
      <div className="stepprogress-bar">
        <div className={`stepprogress-default ${sectionName.toLowerCase()}`}></div>
        <div className={`stepprogress-range ${sectionName.toLowerCase()}`} style={{ width: `calc(${sectionLevel * 10}% - ${sectionLevel * 2}px)` }}></div>
        {Array.from({ length: 10 }, (_, index) => (
          <div key={getRandomNumber(index)} className="stepprogress-indicator"></div>
        ))}
      </div>
      <div className="stepprogress-level">
        <div className="stepprogress-text">0</div>
        <div className="stepprogress-text">Level</div>
        <div className="stepprogress-text">10</div>
      </div>
    </div>
  );
};

export default ProgressIndicator;
